import type { Theme, SxProps } from "@mui/material/styles";
import { dataEntryTableStyles } from "../../../../../../shared/styles/dataEntryTableStyles";

/**
 * Table styles for EAF Data Entry
 * Extends shared dataEntryTableStyles with EAF-specific overrides
 */
export const eafDETablesStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  ...dataEntryTableStyles(theme),
  // EAF-specific overrides
  agGridBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "10px 10px 50px 10px",
    height: "356px",
    minHeight: "356px",
  },
  smAgGridBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "10px 10px 10px 10px",
    height: "305px",
    minHeight: "305px",
  },
});
